import React from 'react';
import {
  Eye, Users, Smile, Compass, ShieldCheck, Wine,
  PartyPopper, Trophy, Lightbulb, MessagesSquare, Sparkles, HeartHandshake,
} from 'lucide-react';

// ---------------------------------------------------------------------------
//  Nativeorange Ethos — shared content (used by this page and the welcome modal)
// Friendly, warm principles for how we show up together at company events.
// ---------------------------------------------------------------------------

export const ETHOS_ITEMS = [
  {
    icon: Eye,
    title: 'Show Up Fully',
    text: 'Be present — phone down, mind on the moment. Every conversation, every session, every meal counts.',
  },
  {
    icon: Users,
    title: 'One Team, One Orange',
    text: "Titles stay at the office. Out here, we're all  Nativeorange. Look out for each other like family.",
  },
  {
    icon: Smile,
    title: 'Carry the Brand Warmly',
    text: "You're the face of  Nativeorange wherever you go. Dress well, smile often, and make us all proud.",
  },
  {
    icon: Compass,
    title: 'Adventures Are Better Together',
    text: 'Exploring the venue, the city, or the unknown? Bring someone along. The best stories have more than one character.',
  },
  {
    icon: ShieldCheck,
    title: 'Stay with Your Squad',
    text: "Heading out? Let someone know. We don't leave people behind, and we don't wander off solo — that's just how we roll.",
  },
  {
    icon: Wine,
    title: 'Drink Merry, Stay Wise',
    text: 'Raise a glass and enjoy the moment — just know your limit and look out for each other. We celebrate together and get home safe together.',
  },
  {
    icon: PartyPopper,
    title: 'Every Activity, Every One',
    text: "Team activities aren't optional fun — they're where the real bonding happens. Jump in with both feet, even if it's a little silly.",
  },
  {
    icon: Trophy,
    title: 'Cheer Loudly, Compete Kindly',
    text: 'Games, challenges, competitions — give it your all and cheer the loudest, win or lose. Good energy is contagious.',
  },
  {
    icon: Lightbulb,
    title: 'Curiosity Over Comfort',
    text: "Talk to someone you haven't met. Switch tables at dinner. The event is as good as the connections you make.",
  },
  {
    icon: MessagesSquare,
    title: 'Speak Up, Listen More',
    text: 'Your ideas matter here. Share them boldly. And when others speak, give them the floor they deserve.',
  },
  {
    icon: Sparkles,
    title: 'Leave It Better',
    text: "Every place we visit, every person we meet — leave a good impression. That's the  Nativeorange standard.",
  },
  {
    icon: HeartHandshake,
    title: 'The Team Code',
    text: "Be kind. Be inclusive. If something doesn't feel right, talk to your buddy or a team lead. We take care of our own.",
  },
];

export default function Ethos() {
  return (
    <div className="ethos-page">
      {/* Hero */}
      <div className="ethos-hero">
        <div className="ethos-hero-glow" />
        <div className="ethos-hero-content">
          <span className="ethos-hero-kicker">
            <Sparkles size={13} />  Nativeorange
          </span>
          <h1 className="ethos-hero-title">Our Ethos</h1>
          <p className="ethos-hero-sub">How we show up, together.</p>
          <p className="ethos-hero-blurb">
            A few friendly reminders for our time together. Not rules — just the
            little things that make a  Nativeorange gathering feel like one big team.
          </p>
        </div>
      </div>

      {/* Grid */}
      <div className="ethos-grid">
        {ETHOS_ITEMS.map((item, i) => {
          const Icon = item.icon;
          return (
            <div className="ethos-card" key={item.title} style={{ animationDelay: `${i * 45}ms` }}>
              <div className="ethos-card-top">
                <span className="ethos-card-icon"><Icon size={20} /></span>
                <span className="ethos-card-num">{String(i + 1).padStart(2, '0')}</span>
              </div>
              <h3 className="ethos-card-title">{item.title}</h3>
              <p className="ethos-card-text">{item.text}</p>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="ethos-footer">
        <HeartHandshake size={16} />
        <span>Made with care by the  Nativeorange team. Let's make it memorable. 🧡</span>
      </div>
    </div>
  );
}
